import { gql } from "@apollo/client";

export const ADMIN_GET_ALL_TRANSFERS = gql`
  query AdminGetAllTransfers($filters: AdminTransferFilters) {
    adminGetAllTransfers(filters: $filters) {
      transfers {
        _id
        orderId
        businessId
        businessName
        orderType
        grossAmount
        stripeFee
        platformFee
        sellerAmount
        status
        releaseDate
        createdAt
        transferredAt
        retryCount
        lastError
      }
      totalCount
      hasMore
    }
  }
`;

export const ADMIN_GET_TRANSFER_DETAILS = gql`
  query AdminGetTransferDetails($transferId: ID!) {
    adminGetTransferDetails(transferId: $transferId) {
      transfer {
        _id
        orderId
        businessId
        stripeAccountId
        customerId
        orderType
        grossAmount
        stripeFee
        platformFee
        sellerAmount
        platformFeesRate
        status
        stripeTransferId
        stripeChargeId
        paymentDate
        serviceDate
        orderDate
        releaseDate
        transferredAt
        retryCount
        lastError
        failureReason
        failureCode
        reversalAmount
        reversalReason
        createdAt
        updatedAt
        feeBreakdown {
          grossAmountDollars
          stripeFeeDollars
          platformFeeDollars
          platformBannerFeeDollars
          platformBannerFeeTaxDollars
          totalPlatformRevenueDollars
          sellerAmountDollars
          sellerPercentage
          platformFeesRate
        }
      }
      order {
        orderId
        orderType
        paymentDate
        completedDate
        stripeChargeId
        paymentIntentId
      }
      business {
        _id
        name
        stripeAccountId
        chargesEnabled
        payoutsEnabled
        verificationStatus
        sellerVerified
      }
      customer {
        _id
        name
        email
        phone
      }
      statusHistory {
        status
        timestamp
        reason
      }
      stripeTransferUrl
      stripeChargeUrl
    }
  }
`;
